import { Component, Injector } from '@angular/core';
import { ColumnDefinition, Filter, PagedCollectionComponent, doMultiSelect, FilterProperty, FilterBuilder, doAlert, createColumnDefinitions, SearchableType } from '@mango/core';
import { User } from './user';
import { UserService } from './user.service';
import { MatDialog } from '@angular/material/dialog';
import { UserFilterComponent } from './user-filter.component';
import { UserMultipleActivationFilterComponent } from './request-multiple-activations/user-multiple-activations-filter.component';


@Component({
    selector: 'pd-user-collection',
    templateUrl: './user-collection.component.html',
    styleUrls: ['./user-collection.component.css']
})
export class UserCollectionComponent extends PagedCollectionComponent<User> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<User>([
        { colDef: 'mfaEnabled', prop: x => x.mfaEnabled, searchable: SearchableType.Boolean},
        { colDef: 'isMfaExempt', prop: x => x.isMfaExempt, searchable: SearchableType.Boolean},
        { colDef: 'firstName', prop: x => x.firstName, searchable: SearchableType.String },
        { colDef: 'lastName', prop: x => x.lastName, searchable: SearchableType.String },
        { colDef: 'email', prop: x => x.email, searchable: SearchableType.String },
        { colDef: 'locked', prop: x => x.locked, searchable: SearchableType.Boolean},
        { colDef: 'lastPasswordChanged', prop: x => x.lastPasswordChanged, searchable: SearchableType.Date},        
        { colDef: 'lastLogin', prop: x => x.lastLogin, searchable: SearchableType.Date},
    ]);
    isNewItem: any;
    item: any;

    constructor(public service: UserService, protected filter: Filter<User>, injector: Injector) {
        super('/users', injector, User);

        this.filter.onGetChipLabel('firstName', () => 'Voornaam');
        this.filter.onGetChipLabel('lastName', () => 'Achternaam');
        this.filter.onGetChipLabel('email', () => 'Email');
        this.filter.onGetChipLabel('mfaEnabled', () => '2FA geactiveerd');
        this.filter.onGetChipLabel('isMfaExempt', () => '2FA vrijgesteld'); 
    }

    ngOnInit() {
        this.orderBy=[3]; 
        super.ngOnInit();
    }

    displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns 
		if(colDef.colDef == 'isMfaExempt' ) { return false; }

		return super.displayColumn(colDef, ix);
	}

    canDelete(){
        return false;
    }
    



}
